import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'maskAccount'
})
export class MaskAccountPipe implements PipeTransform {

  transform(value: string): string {
    const toBeReplaced = value.slice(0, 12);
    return value.replace(toBeReplaced, "•••• •••• •••• ");
  }

}
